import type { FC } from 'react';
import { Card, SkeletonLine, Timeline, TimelineItem } from '@george-labs.com/design-system';

import { getRandomNumber } from '../ProductSkeletonService';

const DEFAULT_NUMBER_OF_ITEMS = 3;
const MIN_HEADING_LINE_WIDTH = 30;
const MAX_HEADING_LINE_WIDTH = 80;
const MIN_LINE_WIDTH = 60;

interface Props {
    className?: string;
    numberOfTimelineItems?: number;
    'data-cy'?: string;
}

export const TimelineSkeleton: FC<Props> = ({
    className,
    numberOfTimelineItems = DEFAULT_NUMBER_OF_ITEMS,
    'data-cy': dataCy,
}) => (
    <Card data-cy={dataCy}>
        <Timeline className={className} useIcons>
            {[...Array(numberOfTimelineItems).keys()].map((index) => (
                <TimelineItem
                    key={`timeline-item-skeleton-${index}`}
                    label={null}
                    icon={TimelineItem.ICON.ACCESSIBILITY}
                    variant={TimelineItem.VARIANT.FADED}
                >
                    <SkeletonLine
                        animated
                        level={3}
                        percentageWidth={getRandomNumber(
                            MIN_HEADING_LINE_WIDTH,
                            MAX_HEADING_LINE_WIDTH,
                        )}
                    />
                    <SkeletonLine
                        animated
                        level={6}
                        percentageWidth={getRandomNumber(MIN_LINE_WIDTH)}
                    />
                </TimelineItem>
            ))}
        </Timeline>
    </Card>
);
